
import Quant from "../../../assets/outline/Quant.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function QuantIcon({ className, dataTestid = "QuantIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Quant data-testid={dataTestid} className={classes} {...rest} />
  );
}
